var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoMiniRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 59 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.782 22.079c0-3.713 2.104-7.424 6.203-10.348C17.073 8.813 22.902 6.9 29.5 6.9c6.598 0 12.426 1.913 16.515 4.83 4.099 2.925 6.203 6.636 6.203 10.349 0 2.137-.683 4.227-2.018 6.182-1.069 1.564-.688 3.714.85 4.801a3.354 3.354 0 004.719-.864c2.028-2.97 3.231-6.41 3.231-10.12 0-6.575-3.74-12.178-9.091-15.996C44.548 2.257 37.322 0 29.5 0 21.678 0 14.452 2.257 9.091 6.082 3.741 9.899 0 15.502 0 22.079c0 6.576 3.74 12.18 9.091 15.997 5.361 3.825 12.587 6.082 20.409 6.082.052 0 .094.042.094.095v5.617c0 .1.106.162.191.112l15.893-9.335a.131.131 0 000-.225l-15.893-9.335a.128.128 0 00-.191.112v5.964a.095.095 0 01-.094.095c-6.598 0-12.427-1.914-16.515-4.83-4.099-2.925-6.203-6.637-6.203-10.35z",
    fill: "#DB3236"
  })));
}

export default SvgLogoMiniRed;